/*
 * @Description: 分组管理和分区管理
 * @Author: gao shuai
 * @Date: 2020-02-25 15:36:33
 * @LastEditTime: 2020-08-31 10:04:46
 * @LastEditors: gao shuai
 */
import api from '../services/api';
export default {
  /* ---------------------1.分组管理----------------------- */
  // 获取分组list
  async teamlist(params) {
  return api({ url: '/api/Group/GetGroupListAsync', method: 'get', params });
  },
  // 添加分组
  async addteam(params) {
  return api({ url: '/api/Group/AddGroupAsync', method: 'post', data: params });
  },
  // 编辑分组
  async editteam(params) {
  return api({ url: '/api/Group/UpdateAsync', method: 'post', data: params });
  },
  // 删除分组
  async deleteteam(params) {
  return api({ url: '/api/Group/DeleteGourpAsync', method: 'post', data: params });
  },
  // 充值
  async rechargeteam(params) {
  return api({ url: '/api/HomePage/GetCircuiteAsync', method: 'get', params });
  },
  /* ---------------------2.分区管理----------------------- */
  // 分区列表
  async arealist(params) {
  return api({ url: '/api/PartitionsManager/GetPartitionsTemplatesListAsync', method: 'get', params });
  },
  // 所属分组下拉
  async belongDrow(params) {
  return api({ url: '/api/InstallPartition/GetGroups', method: 'get', params });
  },
  // 游戏模板下拉
  async gameDrow(params) {
  return api({ url: '/api/PartitionsManager/GetTemplateListAysnc', method: 'get', params });
  },
  // 批量删除分区管理
  async delAreas(params) {
  return api({ url: '/api/PartitionsManager/BatchDeletePartitionsManagerAsync', method: 'post', data: params });
  },
  // 批量排序分区管理
  async sortAreas(params) {
  return api({ url: '/api/PartitionsManager/BatchSortPartitionsManagerAsync', method: 'post', data: params });
  },
  // 获取分区详细信息
  async getAreaInfo(params) {
  return api({ url: '/api/PartitionsManager/GetPartitionDetailAsync', method: 'get', params });
  },
  // 加载分区
  async loadingArea(params) {
  return api({ url: '/api/PartitionsManager/LoadPartitionAsync', method: 'post', data: params });
  },
  // 修改分区
  async editArea(params) {
  return api({ url: '/api/PartitionsManager/UpdatePartitionAsync', method: 'post', data: params });
  },
  // 分区检测
  async checkLink(params) {
  return api({ url: '/api/PartitionsManager/CheckPartition', method: 'get', params });
  },
  // 定时检测分区
  async timerCheck(params) {
  return api({ url: '/api/PartitionsManager/CheckPartitionStatus', method: 'get', params });
  }
};
